import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import Modal from 'react-modal';
import './assets/css/normalize.css';
import './assets/css/bootstrap-grid.min.css';
import './assets/css/bootstrap-utilities.min.css';
import './index.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
Modal.setAppElement('#root');

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/:paymentId" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// NE-13252: ci touch
